import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";
import { PriceAmountField, priceAmountFieldCopy } from "@/components/ListingFields/PriceAmountField";

const LISTING_TYPE = "service" as const;

export interface ServicePriceAmountEditorProps {
  /** ISO currency the price is entered in. */
  currency: string;
  /** Field error, or undefined when valid. */
  error?: string;
  onChange: (value: string) => void;
  /** Platform commission rate (0–1) for the take-home ledger. */
  platformFeeRate: number;
  /** Price in minor units for the ledger, or null until a positive amount is entered. */
  priceCents: number | null;
  /** Current price as a major-unit amount string. */
  value: string;
}

export function ServicePriceAmountEditor({
  currency,
  error,
  onChange,
  platformFeeRate,
  priceCents,
  value,
}: ServicePriceAmountEditorProps) {
  return (
    <EditorSection {...priceAmountFieldCopy(LISTING_TYPE)}>
      <PriceAmountField
        currency={currency}
        error={error}
        listingType={LISTING_TYPE}
        onChange={onChange}
        platformFeeRate={platformFeeRate}
        priceCents={priceCents}
        value={value}
      />
    </EditorSection>
  );
}
